import { THeader } from '../../../../../pages/services/[planSeoSlug]/api/types';

export const getIndividualAndBusinessCategories = (headerData: THeader) => {
  return headerData.filter((headerCategory) => {
    return (
      headerCategory.categoryId === 'individual' ||
      headerCategory.categoryId === 'business'
    );
  });
};

export const geHeaderCategory = (headerData: THeader, category: string) => {
  return headerData.find((headerCategory) => {
    return headerCategory.categoryId === category;
  });
};
